const domaine = "https://nsi-projet-fin-ann-e-backend.vercel.app"

export async function getRecommandations(genres) {
    let res = await fetch(`${domaine}/api/films/recommandations`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(genres)
    })
    res = res.json()
    return res
}



export async function getInfoFilms(input) {
    let res = await fetch(`${domaine}/api/films/find`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ input })
    })
    res = res.json()
    return res
}

export async function makeFilmDb() {
    let i = 501
    while (i !== 2000) {
        let res = await fetch(`https://api.themoviedb.org/3/movie/popular?language=en-US&page=${i}`, {
            method: "GET",
            headers: {
                accept: 'application/json',
                Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJkNzYwYjYzZjMzZjhlNmYyOTA2YThlN2ViYmJjNTA0MyIsInN1YiI6IjYyOGI2MTk2NWNlYTE4NGQxMGVkZDY5MyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.zcSzi3uepLF2PPiKhdNC3ocH4WPwVDFqcW95f_LDupY'
            }
        })
        i++
        res = await res.json()
        console.log("Page " + i, res)

        await fetch(`${domaine}/api/films/add`, {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(res)
        })
    }
}
// makeFilmDb()


export async function getRecommandationsByAnnee(from, to) {
    let res = await fetch(`${domaine}/api/films/recommandations_annee`, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ from, to })
    })
    res = res.json()
    return res
}
